import {
    Component,
    OnInit,
    OnDestroy,
    Output,
    EventEmitter,
    ViewChild,
    ElementRef} from '@angular/core';
// angular import
import { Http } from '@angular/http';
import { ServerMapping } from './../../service/serverMapping.service';
import { AccountService } from './../../service/accountService.service';
import { Locale } from './../../service/locale.service';
import { Status } from './../../service/status.service';
import { SelectProfileComponent } from './../MODAL-select-profile/select-profile.component';

import { PlswaitComponent } from './../MODAL-plswait/plswait.component';
import {CustomizingService} from '../../service/customizingService.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit{
    @Output() loginEventLaunched = new EventEmitter<boolean>();
    @ViewChild('loginName') loginName: ElementRef;
    @ViewChild('password') password: ElementRef;
    @ViewChild('recoverEmail') recoverEmail: ElementRef;
    @ViewChild('selectprofileModal') selectProfileModal: SelectProfileComponent;

    private forgotPasswordForm = false;
    public  forgot_password_show = false;

    private autolog = false; // FOR DEV PROPOUSES
    private profileSelection = false;

    private plsWait = undefined;
    private resetPasswordLabel = '';
    private resetStatus = '';

    constructor(private accountService: AccountService,
                private customizing_srv: CustomizingService,
                private serverMapping: ServerMapping,
                private locale: Locale,
                private status: Status,
                private http: Http) {

		// Bridge creations
        this.accountService.setLoginComponentBridge(this);
    }
    ngOnInit(): void {
      this.forgot_password_show = this.customizing_srv.getBoolean('SERVICE.LOGIN.RESET_PASSWORD.ENABLE', 'false');
    }

  onLoginRequestButtonPressed(plsWait: PlswaitComponent) {
        this.plsWait = plsWait;
        this.plsWait.show();
        const loginNameValue = this.loginName.nativeElement.value;
        const passwordValue = this.password.nativeElement.value;
        this.doLogin(loginNameValue, passwordValue);
        // this.loginEventLaunched.emit(true)
    }

    setProfileSelection(value: boolean) {
        this.profileSelection = value;
        this.selectProfileModal.recalcProfiles();
        this.selectProfileModal.show();
        this.plsWait.hide();
    }

    doLogin(loginNameValue: string, passwordValue: string) {
        this.accountService.setLoginName(loginNameValue);
        this.accountService.setPassword(passwordValue);
        this.accountService.doLogin(this.plsWait);
    }

    requestPassword() {
        let params = {};
        params['username'] = this.recoverEmail.nativeElement.value;

        this.http.get(this.serverMapping.resetPasswordURL + '?username=' + this.recoverEmail.nativeElement.value).subscribe((response) => {
            const data = response.json();
            if (data.result === false) {
                this.resetPasswordLabel = data.result_warning;
                this.resetStatus = '1';
            } else {
                this.resetPasswordLabel = this.locale.getMiscTerms().CHECK_EMAIL;
                this.resetStatus = '2';
            }
            console.log(data);
        });
    }

    doOauth2(){
          // Recupero l'url con cui spo è stato chiamato.
    let origin_sup_url = window.location.href;
    console.log("URL from: " + origin_sup_url);

    // Verifico se nell'url c'è la stringa "telwin" o "valex"
    let telwin = origin_sup_url.indexOf("telwin") >= 0;
    // Verifico se nell'url c'è la stringa "telwin" o "valex"
    let localhost = origin_sup_url.indexOf("localhost") >= 0;

    /*
      https://spotest.telwin.com
      https://spotest.valex.it
    */


    let brand = undefined;
    let host = window.location.origin;;
    if(localhost){
      brand = 'local';
      // host = window.location.origin;
    }else if(telwin){
      brand = 'telwin';
      //host = 'https://suptest.telwin.com';
    }else{
      brand = 'valex';
      // host = 'https://suptest.valex.it';
    }

    console.log(host + "/supplyportal-ws-horsa/access/oauth2/authorize?brand=" + brand);
    window.location.href=host + "/supplyportal-ws-horsa/access/oauth2/authorize?brand=" + brand;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts